import { render, staticRenderFns } from "./chateau-la-fleur-petrus.vue?vue&type=template&id=4c3668dd&scoped=true"
import script from "./chateau-la-fleur-petrus.vue?vue&type=script&lang=js"
export * from "./chateau-la-fleur-petrus.vue?vue&type=script&lang=js"
import style0 from "./chateau-la-fleur-petrus.vue?vue&type=style&index=0&id=4c3668dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3668dd",
  null
  
)

export default component.exports